
import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const dashboardTourConfig: TourConfig = {
    tourId: 'dashboard',
    steps: [
        {
            element: '#dashboard-welcome',
            popover: {
                title: '🏠 Welcome Home',
                description: 'This is your central command center. From here, you act as the pilot of your entire TechUnity experience. We give you a bird\'s-eye view of everything happening in your workspace.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-stats',
            popover: {
                title: '📊 Real-Time Analytics',
                description: 'Track your performance instantly. See how many Active Projects you are juggling, your Tracked Hours for the day, and active collaboration Rooms. These numbers update in real-time.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-quick-actions',
            popover: {
                title: '⚡ Rapid Access Grid',
                description: 'Navigate anywhere in one click. We have placed your most critical tools right here for speed and efficiency.',
                side: "left",
            }
        },
        {
            element: '#dashboard-action-new-project',
            popover: {
                title: '🚀 Launch New Project',
                description: 'Have a new idea? Click here to instantly spin up a workspace, invite your team, and start building.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-find-talent',
            popover: {
                title: '🔍 Recruit Talent',
                description: 'Need help? Search our global database of elite developers, designers, and engineers to join your squad.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-join-meeting',
            popover: {
                title: '🎥 Enter Meeting Room',
                description: 'Jump straight into your active video calls or 3D collaboration sessions without digging through links.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-3d-hub',
            popover: {
                title: '🧊 The 3D Hub',
                description: 'Access the world\'s largest library of 3D assets, scenes, and environments for your immersive projects.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-skills',
            popover: {
                title: '⚡ Skills Matrix',
                description: 'Update your professional profile, add new capabilities, and visualize your growth in 3D.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-academy',
            popover: {
                title: '🎓 TechUnity Academy',
                description: 'Upskill yourself. Access courses, certifications, and learning paths to stay ahead of the curve.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-ai-hub',
            popover: {
                title: '🤖 AI Companion',
                description: 'Chat with UnityBot, your AI assistant. Get help with code, design, or platform questions instantly.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-action-my-vault',
            popover: {
                title: '💰 Financial Vault',
                description: 'Securely manage your earnings, payments, and assets in your personal vault.',
                side: "bottom",
            }
        },
        {
            element: '#dashboard-activity',
            popover: {
                title: '📋 Live Feed',
                description: `Stay updated. This feed shows you the latest updates on projects, team actions, and system notifications as they happen.${CONTINUE_PLATFORM_TOUR_BUTTON}`,
                side: "left",
            }
        }
    ],
};

export const startDashboardTour = () => {
    startTour(dashboardTourConfig);
};

const DashboardTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to Dashboard"
            description="Your command center for everything TechUnity. Let's show you around."
            onStartTour={startDashboardTour}
            tourId="dashboard"
        />
    );
};

export default DashboardTour;
